import type { ICookieTokens } from '~/types/authentication';
const TOKEN_MAX_AGE = 60 * 60 * 24;
const REFRESH_TOKEN_MAX_AGE: number = 60 * 60 * 24 * 366;
export const useAdamTokens = () => {
  const runtimeConfig = useRuntimeConfig();
  const defaultValue: ICookieTokens = {
    id: '',
    token: '',
    refreshToken: '',
    exp: -1,
    expRefresh: -1,
  };
  const tokens = useCookie<ICookieTokens>(runtimeConfig.public.cookieName, {
    maxAge: 60 * 60 * 24 * 20 * 5,
    domain: runtimeConfig.public.cookieDomain,
    watch: true,
  });
  const setTokens = ({ id, token, refreshToken }) => {
    tokens.value = {
      id,
      token,
      refreshToken,
      exp: Date.now() + TOKEN_MAX_AGE * 1000,
      expRefresh: Date.now() + REFRESH_TOKEN_MAX_AGE * 1000,
    };
  };
  const setNewTokens = ({ token, refreshToken }) => {
    globalThis.$logger.info('useAdamTokens :: set new token', token);
    tokens.value = {
      ...tokens.value,
      token,
      refreshToken,
      exp: Date.now() + TOKEN_MAX_AGE * 1000,
      expRefresh: Date.now() + REFRESH_TOKEN_MAX_AGE * 1000,
    };
  };
  const switchToken = (token) => {
    tokens.value = {
      ...tokens.value,
      token,
      refreshToken: '',
      exp: Date.now() + TOKEN_MAX_AGE * 1000,
      expRefresh: Date.now() + REFRESH_TOKEN_MAX_AGE * 1000,
    };
  };
  const token = computed((): string => {
    return tokens.value?.token;
  });
  const refreshToken = computed((): string => {
    return tokens.value?.refreshToken;
  });
  const getTokens = (): ICookieTokens => {
    if (!tokens.value.token) return undefined;
    globalThis.$logger.info('useAdamTokens :: use token', tokens.value.id);
    return {
      id: tokens.value.id,
      refreshToken: tokens.value.refreshToken,
      token: tokens.value.token,
    };
  };
  const clearTokens = async (): Promise<void> => {
    tokens.value = { ...defaultValue };
    return await new Promise((resolve) => setTimeout(resolve, 500));
  };
  const hasTokenExpired = (): boolean => {
    if (!tokens?.value?.exp) return false;
    return tokens.value.exp - Date.now() < 500;
  };
  const memberId = computed((): string => {
    try {
      const resultToken = JSON.parse(atob(token.value.split('.')[1]));
      const memberId = resultToken.m;
      return memberId as string;
    } catch (e) {
      return null;
    }
  });
  const userId = computed((): string => {
    return tokens.value?.id ?? null;
  });
  return {
    clearTokens,
    setTokens,
    setNewTokens,
    token,
    refreshToken,
    memberId,
    getTokens,
    hasTokenExpired,
    userId,
    switchToken,
  };
};
